import BankBalancesContainer from 'containers/panel/admin/bank-balances-container'

const BankBalancesPage = () => {
  return (
    <BankBalancesContainer />
  );
};

export default BankBalancesPage; 